const styles = {
    title: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '14px',
        lineHeight: '21px',
        textAlign: 'left',
        color: '#001533',
        paddingLeft: '16px',
        fontWeight: '600',
        textTransform: 'capitalize',
    },
    heading: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '250px',
    },
    author: {
        width: '250px',
        verticalAlign: 'top',
        fontFamily: 'Silka_Regular',
        fontSize: '12px',
        lineHeight: '18px',
        fontWeight: '400',
        color: '#4D5C71',
    },
    visibility: {
        textAlign: 'center',
        cursor: 'pointer',
    },
    continue: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '8px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: 'white',
        textTransform: 'none',
        backgroundColor: '#ED0000',
    },
    cancel: {
        fontFamily: 'Silka_Semi_Bold',
        fontSize: '16px',
        lineHeight: '16px',
        textAlign: 'center',
        borderRadius: 2,
        p: 2,
        color: '#3876AA',
        textTransform: 'none',
        mr: 2,
        borderWidth: '2px',
    },
};
export default styles;
